import { useState } from 'react';
import { signoffViva } from '../lib/api';

/**
 * A step a Khalifa completes after the learner's live demo and viva. Learners see what to
 * expect; a Khalifa sees a small form to sign off a learner by email.
 */
export default function VivaSignoff({ trackId, stepId, isAdmin }: { trackId: string; stepId: string; isAdmin: boolean }) {
  const [email, setEmail] = useState('');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    setStatus(null);
    const res = await signoffViva(trackId, stepId, email.trim(), note.trim());
    setBusy(false);
    if (res.ok && res.data.ok) setStatus(res.data.alreadyDone ? 'Already signed off.' : `Signed off ${email.trim()}.`);
    else {
      const code = (res.data as { error?: string })?.error ?? `http_${res.status}`;
      setStatus(code === 'learner_not_found' ? 'No learner with that email.' : 'Could not sign off. Please try again.');
    }
  };

  return (
    <div className="mt-5 rounded-xl border border-rule bg-paper-0 p-4 dark:border-clay-rule dark:bg-clay-surface">
      <p className="text-sm text-ink-700 dark:text-paper-200">
        Your Khalifa marks this step done after your live demo and viva with the team. You do not need to do anything here.
      </p>
      {isAdmin && (
        <div className="mt-4 border-t border-rule pt-4 dark:border-clay-rule">
          <p className="text-xs font-semibold uppercase tracking-wider text-terracotta-500">Khalifa sign-off</p>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Learner's email"
            className="mt-2 w-full rounded-lg border border-rule bg-paper-50 px-3 py-2 text-sm outline-none focus:border-terracotta-300 dark:border-clay-rule dark:bg-clay-floor"
          />
          <input
            type="text"
            maxLength={280}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="One line on how the demo went (optional)"
            className="mt-2 w-full rounded-lg border border-rule bg-paper-50 px-3 py-2 text-sm outline-none focus:border-terracotta-300 dark:border-clay-rule dark:bg-clay-floor"
          />
          <button
            onClick={() => void submit()}
            disabled={busy || !email.trim()}
            className="mt-3 rounded-lg bg-terracotta-500 px-3 py-2 text-sm font-semibold text-white hover:bg-terracotta-600 disabled:opacity-50"
          >
            {busy ? 'Signing off…' : 'Sign off this learner'}
          </button>
          {status && <p className="mt-2 text-sm text-ink-700 dark:text-paper-200">{status}</p>}
        </div>
      )}
    </div>
  );
}
